import React from 'react';

export function ReviewTypeDeleteConfirm() {
  return (
    <div>
      <p>Are you sure?</p>
      <p>
        Deleting this meeting type will make it unavailable to any future coaching plans. Historical
        or in progress coaching plans which used this meeting type will still be valid.
      </p>
      <p>Click "Yes" to delete this meeting type, "No" to keep it available.</p>
    </div>
  );
}
